

















interface CashProjectList {
    code: null;
    fold: null;
    foldFlag: null;
    formula: null;
    id: number;
    initbalance: null;
    isInit: null;
    item: string;
    lyearCashBD: null;
    monthCashBD: null;
    row: null;
    rowIndex: null;
    yearCashBD: null;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class CashProject extends Vue {
    @Prop({ type: Number })
    detailId?: number;

    dataList: CashProjectList[] = [];
    itemId: number = 0;

    mounted() {
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(`cashdetail/finditems`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                this.dataList = res.data;
            });
    }
    addColor(event: any, id: number, row: number) {
        if (row === null) return;
        this.itemId = id;
        let pTags: any = document.querySelectorAll("#CashProject p");
        for (var i = 0; i < pTags.length; i++) {
            if (pTags[i].classList.contains("lighter-main-color-background"))
                pTags[i].classList.remove("lighter-main-color-background");
        }
        event.currentTarget.classList.add("lighter-main-color-background");
    }

    // 确定科目
    success() {
        if (this.itemId === null) {
            this.$emit("close");
            return;
        }
        Vue.axios
            .post("cashdetail/" + this.detailId + "/edit", {
                id: this.itemId
            })
            .then(res => {
                if (res.status === 200) {
                    this.$emit("success");
                }
            });
    }
    close() {
        this.$emit("close");
    }
}
